module.exports = __webpack_public_path__ + "img/3.c7bd2191.jpg";